export default "__VITE_ASSET__BySXjucy__"